import Vue from 'vue';
import '@mdi/font/css/materialdesignicons.css';
import Vuetify from 'vuetify/lib/framework';
import VTooltip from 'vuetify/lib/components/VTooltip/VTooltip';
import { vuetifyThemeLight } from '@/styles/design-tokens';

// Product-wide: delay tooltip open so brief hover/pass-through does not flash tooltips.
// Per-instance open-delay still overrides this default when set explicitly.
const TOOLTIP_OPEN_DELAY_MS = 500;
if (VTooltip.options?.props?.openDelay) {
    VTooltip.options.props.openDelay.default = TOOLTIP_OPEN_DELAY_MS;
}

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: { light: vuetifyThemeLight },
        options: {
            customProperties: true
        }
    },
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
});
